import { useTranslation } from 'react-i18next';
import { Heading, Tag } from '@digdir/designsystemet-react';
import type { OrganizationUser } from '../../../../api/queries';
import classes from '../Users.module.css';

/** Initial, e-post, når brukeren ble opprettet og status */
export const UserSummary = ({ user }: { user: OrganizationUser }) => {
  const { t, i18n } = useTranslation();
  const created = new Date(user.createdAt).toLocaleString(i18n.language === 'en' ? 'en-GB' : 'nb-NO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className={classes.summary}>
      <span aria-hidden="true" className={`${classes.avatar} ${classes.avatarLarge}`}>
        {user.email[0]?.toUpperCase()}
      </span>
      <div className={classes.summaryText}>
        <Heading level={2} data-size="sm" className={classes.email}>
          {user.email}
        </Heading>
        <span className={classes.subtle}>{t('organizationPage.users.created', { date: created })}</span>
      </div>
      <UserStatusTag user={user} />
    </div>
  );
};

export const UserStatusTag = ({ user }: { user: OrganizationUser }) => {
  const { t } = useTranslation();
  return user.isPending ? (
    <Tag data-size="sm" data-color="warning">
      {t('users.overview.status.pending')}
    </Tag>
  ) : (
    <Tag data-size="sm" data-color="success">
      {t('users.overview.status.active')}
    </Tag>
  );
};
